import React from 'react';
import PropTypes from 'prop-types';

import DefaultSidebarBody from 'apps/ddo/components/DefaultSidebarBody';
import LikesSidebarBody from 'apps/ddo/components/LikesSidebarBody';
import { SidebarPanes, DdoCommentProps } from 'apps/ddo/propTypes';
import { SIDEBAR_PANE_DEFAULT, SIDEBAR_PANE_LIKES_LIST } from 'apps/ddo/consts';

export default class SidebarBodyPane extends React.Component {
    constructor(props) {
        super(props);

        this.setDefaultPane = this.setDefaultPane.bind(this);
    }

    setDefaultPane() {
        this.props.onPaneChange(SIDEBAR_PANE_DEFAULT);
    }

    render() {
        if (this.props.activePane === SIDEBAR_PANE_LIKES_LIST) {
            return (
                <LikesSidebarBody
                    likes={this.props.design.likes}
                    onOverviewButtonClick={this.setDefaultPane}
                    designLikesUrl={this.props.design.links.designLikesUrl}
                />
            );
        }

        return (
            <DefaultSidebarBody
                design={this.props.design}
                activeUser={this.props.activeUser}
                isLoadingComments={this.props.isLoadingComments}
                comments={this.props.comments}
                selectedComment={this.props.selectedComment}
                selectedCommentStatus={this.props.selectedCommentStatus}
                selectedCommentEditingLocation={this.props.selectedCommentEditingLocation}
            />
        );
    }
}

SidebarBodyPane.defaultProps = {
    selectedComment: null,
    selectedCommentStatus: null,
    selectedCommentEditingLocation: null,
    onPaneChange: () => undefined,
};

SidebarBodyPane.propTypes = {
    onPaneChange: PropTypes.func,
    activePane: SidebarPanes.isRequired,
    design: PropTypes.object.isRequired,
    activeUser: PropTypes.object.isRequired,
    ...DdoCommentProps,
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/SidebarBodyPane.jsx